import { render, staticRenderFns } from "./OZGForms.vue?vue&type=template&id=211d12cc"
import script from "./OZGForms.vue?vue&type=script&lang=js"
export * from "./OZGForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports